import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Box, Button, Card, Column, Divider, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { BrandSettingsBody } from './BrandSettingsBody/BrandSettingsBody';
import styles from './BrandSettingsSection.module.scss';
import { useBrandSettingsForm } from './hooks/useBrandSettingsForm';
function saveButtonTooltip(isDirty, isValid, invalidFieldText) {
    if (!isDirty) return '';
    if (!isValid) return invalidFieldText;
    return '';
}
const testPrefix = 'settings-business-details-brand';
export const GetBrandSettingsSectionTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const BrandSettingsSection = (param)=>{
    let { testId = testPrefix, worksAt, onDirtyChange } = param;
    var _logo_asDataURL;
    const { t } = useLocaleKeys('pages.businessDetails.brandSettings');
    const { t: pageTexts } = useLocaleKeys('pages.businessDetails');
    const testIds = useMemo(()=>GetBrandSettingsSectionTID(testId), [
        testId
    ]);
    const { BrandSettingsSectionTestIds } = testIds;
    const { branding, setBranding, logo, setLogo, isDirty, isValid, errors, save, saving } = useBrandSettingsForm({
        worksAt
    });
    useEffect(()=>{
        onDirtyChange === null || onDirtyChange === void 0 ? void 0 : onDirtyChange(isDirty);
    }, [
        isDirty,
        onDirtyChange
    ]);
    const handleLogoChange = (data)=>{
        if (data) {
            setLogo({
                file: data.file,
                asDataURL: data.asDataURL
            });
        }
    };
    return /*#__PURE__*/ _jsxs(Card, {
        bi: {
            name: 'brand_settings_card'
        },
        className: styles.card,
        autoHeight: true,
        padding: "m",
        disableSeparator: true,
        title: /*#__PURE__*/ _jsxs(Column, {
            gap: 0,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "normal",
                    children: t.title()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: t.subtitle()
                })
            ]
        }),
        testId: BrandSettingsSectionTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                margin: 8
            }),
            /*#__PURE__*/ _jsx(BrandSettingsBody, {
                testId: testId,
                previewTestId: BrandSettingsSectionTestIds.Preview(),
                branding: branding,
                errors: errors,
                setBranding: setBranding,
                logoImage: (_logo_asDataURL = logo.asDataURL) !== null && _logo_asDataURL !== void 0 ? _logo_asDataURL : '',
                onLogoChange: handleLogoChange,
                saving: saving
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.saveButtonWrapper,
                children: /*#__PURE__*/ _jsx(Button, {
                    disabled: !isDirty || !isValid || saving,
                    loading: saving,
                    onClick: save,
                    testId: BrandSettingsSectionTestIds.Save(),
                    bi: {
                        name: 'save_brand_settings'
                    },
                    tooltip: {
                        placement: 'top',
                        title: saveButtonTooltip(isDirty, isValid, t.oneOfTheFieldsIsInvalid())
                    },
                    children: pageTexts.saveChanges()
                })
            })
        ]
    });
};
